import { Avatar, Box, IconButton, Typography } from '@mui/material';
import MessagePreview from 'components/@home/@messages/ChatPanel/PinnedMessage/MessagePreview';
import isEmpty from 'lodash/isEmpty';
import CloseIcon from 'mdi-react/CloseIcon';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { I18n } from 'utils/i18n';
import messageShape from 'shapes/message';

const PinnedMessage = ({ message = null, onUnpin = () => {}, canUnpin = true, onClick }) => {
  const handleUnpin = useCallback(() => {
    onUnpin(message);
  }, [onUnpin, message]);
  const handleClick = useCallback(() => {
    onClick(message);
  }, [onClick, message]);
  const att = message?.attachments?.[0] || {};
  if (isEmpty(message) || !message.createdAt) {
    return null;
  }
  return (
    <Box
      component="button"
      type="button"
      onClick={handleClick}
      sx={theme => ({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'stretch',
        border: 'none',
        boxShadow: 'none',
        backgroundColor: theme.palette.secondary.ultraUltraLight,
        borderBottom: `1px solid ${theme.palette.divider}`,
        width: '100%',
        textAlign: 'left',
      })}
    >
      <Box
        sx={theme => ({
          width: 3,
          marginRight: '5px',
          borderRadius: '3px',
          backgroundColor: theme.palette.primary.light,
          margin: '8px 4px 4px 0px',
        })}
      />
      {att.meta?.thumb && (
        <Box sx={{ marginTop: '4px', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <Avatar
            variant="rounded"
            alt=""
            src={att.meta?.thumb}
            sx={{ width: 35, height: 35, marginRight: '5px' }}
          />
        </Box>
      )}
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <Box sx={{ flex: 1, color: 'secondary.main' }}>
          <Typography sx={{ color: 'primary.main', fontWeight: 600 }}>
            {I18n.t('PinnedMessage')}
          </Typography>
          <MessagePreview message={message} showImages={false} />
        </Box>
        {canUnpin && (
          <IconButton onClick={handleUnpin} size="large" sx={{ marginRight: '10px' }}>
            <CloseIcon />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};

PinnedMessage.propTypes = {
  message: messageShape,
  canUnpin: PropTypes.bool,
  onUnpin: PropTypes.func,
  onClick: PropTypes.func.isRequired,
};

export default PinnedMessage;
